require("./bootstrap");
var cookieModule = require("./cookie");
var questionaireModule = require("./questionaire");
var headerNotificationModule = require("./header-notification");
var filtersModule = require("./filters");
var productFilterModule = require("./product-filter");
var maintenanceModule = require("./maintenance");
var scrollToHashModule = require("./scrollToHash");
var priceToggleModule = require("./price-toggle");
var viewportModule = require("./viewport");
var colorSelectorModule = require("./color-selector");
var menuModule = require("./menu");
var togglerModule = require("./toggler");

var $ = require("jquery");
window.jQuery = window.$ = $;

import intlTelInput from "intl-tel-input";
import MatchHeight from "@tannerhodges/match-height";

function inDom(selector) {
    if ($(selector).length > 0) {
        return $(selector);
    }
    return null;
}

$(document).ready(function () {
    var cookies = new cookieModule();
    cookies.init();

    var menu = new menuModule();
    menu.init();

    var toggler = new togglerModule();
    toggler.init();

    var questionaire = new questionaireModule();
    questionaire.init();

    var colorSelector = new colorSelectorModule();
    colorSelector.init();

    var headerNotification = new headerNotificationModule();
    headerNotification.init();

    var productFilter = new productFilterModule(new filtersModule());
    productFilter.listen();

    var maintenance = new maintenanceModule(new filtersModule());
    maintenance.render();

    // var scrollToHash = new scrollToHashModule();
    // scrollToHash.render();

    var priceToggle = new priceToggleModule();
    priceToggle.listen();

    var viewportHelper = new viewportModule();
    viewportHelper.create(0, 766, function () {
        $(".nav-link-toggle").on("click", function (e) {
            e.preventDefault();
        });
    });

    /**
     * Hide scroll to button when target is found
     */
    $("#call-to-action-container").on("scroll", function () {
        var element = document.querySelector("#submit-your-review");
        if (element) {
            var position = element.getBoundingClientRect();
            if (position.top >= 0 && position.bottom <= window.innerHeight) {
                $(".u-go-to-modern").fadeOut();
            }
        }
    });

    var goToModern = document.querySelectorAll(".u-go-to-modern");

    if (goToModern) {
        goToModern.forEach((anchor) => {
            anchor.addEventListener("click", function (e) {
                e.preventDefault();
                document
                    .querySelector(this.getAttribute("href"))
                    .scrollIntoView({
                        behavior: "smooth",
                    });
            });
        });
    }

    /**
     * Handle show if filled
     */
    $("[data-show-if-filled]").each(function () {
        var $this = $(this);
        var selector = $this.attr("data-show-if-filled");
        $(selector).on("change", function () {
            var $selector_this = $(this);
            if ($selector_this.val()) {
                $this.removeClass("d-none");
            } else {
                $this.addClass("d-none");
            }
        });
    });

    $("[data-on-click-fill]").each(function () {
        var $this = $(this);
        $this.on("click", function (event) {
            event.preventDefault();
            var settings = $this.attr("data-on-click-fill").split(";");
            $.each(settings, function (index, value) {
                var options = value.split("|");
                $(options[0]).val(options[1]);
                $(options[0]).trigger("change");
            });
        });
    });

    $("#quantity_input").on("change", function () {
        var quantity = $(this).val();
        $("[data-one-ear]").each(function () {
            if (quantity == 2) {
                $(this).text($(this).attr("data-two-ears"));
            } else {
                $(this).text($(this).attr("data-one-ear"));
            }
        });
    });

    $("[data-on-click-toggle]").each(function () {
        var $this = $(this);
        $this.on("click", function () {
            var $clicked = $(this);
            var group = $clicked.attr("data-on-click-toggle");
            var options = group.split("|");
            $('[data-on-click-toggle="' + group + '"]').removeClass(options[1]);
            $clicked.addClass(options[1]);
        });
    });

    function validateDataVisableIfIsTrue($element, settings, operator) {
        var show = false;
        var matches = 0;

        $.each(settings, function (index, value) {
            var options = value.split("=");
            if ($(options[0]).val() == options[1]) {
                matches++;
            }
        });

        if (matches > 0 && operator == "OR") {
            show = true;
        } else if (matches == settings.length && operator == "AND") {
            show = true;
        } else if (matches > 0 && !operator) {
            show = true;
        }

        if (show === true) {
            if ($element.hasClass("d-none")) {
                var loader_selector = $element.attr("data-visable-if-loader");
                if (loader_selector) {
                    $element.addClass("block-is-loading");
                    $(loader_selector).removeClass("d-none");
                    $(loader_selector).show();
                    setTimeout(function () {
                        $(loader_selector).fadeOut("slow", function () {
                            $(loader_selector).addClass("d-none");
                            $element.removeClass("block-is-loading");
                        });
                    }, 800);
                }
                $element.removeClass("d-none");
            }
        } else {
            $element.addClass("d-none");
        }
    }

    $("[data-visable-if]").each(function () {
        var $this = $(this);
        var settings = $this.attr("data-visable-if").split(";");
        var operator =
            settings.length > 1 ? $this.attr("data-visable-if-operator") : null;

        validateDataVisableIfIsTrue($this, settings, operator);

        $.each(settings, function (index, value) {
            var options = value.split("=");
            $(options[0]).on("change", function () {
                validateDataVisableIfIsTrue($this, settings, operator);
            });
        });
    });

    $("[data-hide-when-checked]").on("change", function () {
        var $this = $(this);
        var selector = $this.attr("data-hide-when-checked");
        var $target = $($this.attr("data-show-loader"));
        if ($this.prop("checked")) {
            $(selector).hide();
        } else {
            $(selector).show();
        }

        $target.addClass("block-is-loading");
        $target.find(".full-block-loader").removeClass("d-none");

        setTimeout(function () {
            $target.removeClass("block-is-loading");
            $target.find(".full-block-loader").addClass("d-none");
        }, 1000);
    });

    $("body").on("click", "[data-toggle-appointment]", function (event) {
        var $element = $(this);

        Livewire.dispatch(
            "setAppointmentHearingAid",
            $element.attr("data-product-id")
        );
        Livewire.dispatch("setSource", $element.attr("data-source"));

        const showEvent = new Event("show-appointment-model");
        window.dispatchEvent(showEvent);
    });

    $("body").on("click", "[data-toggle-element]", function (event) {
        event.preventDefault();
        var $this = $(this);
        var all_element_selector = $this.attr("data-toggle-element");
        var element_to_show = $this.attr("data-toggle-this-element");
        var active_text = $this.attr("data-toggle-active-text");
        var inactive_text = $this.attr("data-toggle-inactive-text");
        var is_active = $this.hasClass("toggle-activated");

        $('[data-toggle-element="' + all_element_selector + '"]').each(
            function () {
                var $_this = $(this);
                $_this.removeClass("toggle-activated");
                $($_this.attr("data-toggle-this-element")).addClass("d-none");
                $_this.html(inactive_text);
            }
        );

        if (!is_active) {
            $this.addClass("toggle-activated");
            $this.html(active_text);
            $(element_to_show).removeClass("d-none");
        }
    });

    $("body").on("click", ".clickable-row", function () {
        window.location = $(this).data("href");
    });

    $("body").on("click", ".hrefable", function () {
        window.location = $(this).data("href");
    });

    $("body").on("click", ".iti__flag-container", function () {
        var $container = $(this).parents(
            ".country-phonenumber-selector-container"
        );
        var $list = $container.find(".iti__country-list");
        if ($list.hasClass("iti__hide")) {
            $list.removeClass("iti__hide");
        } else {
            $list.addClass("iti__hide");
        }
    });

    $("body").on("click", "[data-dial-code]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $clicked = $(this);
        var $container = $clicked.parents(
            ".country-phonenumber-selector-container"
        );
        var $country_code_input = $container.find(".js-country-code-input");
        $country_code_input.val($clicked.attr("data-dial-code"));
        $country_code_input.trigger("change");
        $country_code_input.trigger("update");

        Livewire.dispatch(
            "countryCodeChanged",
            $clicked.attr("data-dial-code"),
            $country_code_input.attr("wire:model")
        );

        var $list = $container.find(".iti__country-list");
        $list.addClass("iti__hide");

        var $active_flag = $container.find(".iti__selected-flag");
        $active_flag.attr(
            "title",
            $clicked.find(".iti__country-name").text() +
                ": " +
                $clicked.find(".iti__dial-code").text()
        );
        $active_flag.attr("aria-activedescendant", $clicked.attr("id"));
        $active_flag.find(".iti__flag").remove();

        var $flag = $clicked.find(".iti__flag-box .iti__flag").clone();
        $active_flag.prepend($flag);
    });

    /**
     * Automaticly open the subscribe modal
     */
    if (show_register_modal) {
        while (true) {
            if (inDom(".hs-unfold-overlay")) {
                $(".hs-unfold-overlay").css({
                    display: "block",
                });
                $("#sidebarContent")
                    .addClass("fadeInRight")
                    .removeClass("hs-unfold-hidden");
                $("#login").hide();
                $("#signup").css({
                    opacity: 1,
                    animationDuration: "400ms",
                    display: "block",
                });
                break;
            }
        }
    }
});

// Alpine.js circle component
window.alpineCircle = (value, maxValue, color, label) => {
    return {
        value: value,
        maxValue: maxValue,
        color: color,
        label: label,
        radius: 50,
        circumference: 2 * Math.PI * 50, // 2 * PI * radius
        
        get dashOffset() {
            const currentValue = parseInt(this.value) || 0;
            const progress = currentValue / this.maxValue;
            return this.circumference - (progress * this.circumference);
        }
    };
};
